import _objectSpread from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.to-string.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/images/right_arrow_gray.svg';
var _hoisted_1 = ["onClick"];
var _hoisted_2 = {
  class: "select-ctn"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = {
  class: "text-ctn"
};
var _hoisted_5 = {
  class: "text-name-wrap"
};
var _hoisted_6 = {
  class: "text-name text-ellipsis-1"
};
var _hoisted_7 = {
  class: "text-mobile"
};
var _hoisted_8 = {
  class: "text-desc"
};
var _hoisted_9 = ["onClick"];
var _hoisted_10 = {
  class: "al-empty"
};
var _hoisted_11 = {
  class: "al-footer"
};
var _hoisted_12 = {
  class: "al-bottom"
};
import { ref, computed, onMounted, nextTick } from "vue";
import Button from "@/components/base/Button.vue";
import { useAddressStoreWithOut } from "@/store/addressStore";
import { useRouter } from "@/hooks/useRouter";
import { formatLocation } from "@/utils/format";
// import { showToast } from "@/utils/toastUtil";
import { useShopStoreWithOut } from "@/store/shopStore";
import { useAddress } from "@/hooks/useAddress";
import { useUserStoreWithOut } from "@/store/userStore";
import { OrderTypeEnum } from "@/constant/order";
import { useRoute } from "vue-router";
import StickyPowerBy from "@/components/StickyPowerBy.vue";
import Dialog from "@/components/dialog/dialog";
import { Notify } from "@/utils/notifyUtil";
import router from "@/router";
import { hideLoading, showLoading } from "@/utils/loadingUtil";
import { useI18n } from "vue-i18n";
import { showToast } from "@/utils/toastUtil";
export default {
  __name: 'AddressList',
  setup: function setup(__props) {
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var route = useRoute();
    var _useAddress = useAddress(),
      selfDeliveryGetShop = _useAddress.selfDeliveryGetShop;
    var _useRouter = useRouter(),
      routerBack = _useRouter.routerBack,
      routerPush = _useRouter.routerPush,
      routerReplace = _useRouter.routerReplace;
    var userStore = useUserStoreWithOut();
    var shopStore = useShopStoreWithOut();
    var addressStore = useAddressStoreWithOut();
    var addressList = computed(function () {
      return addressStore.getAddressList;
    });
    var selectedAddressId = ref(addressStore.getSelectId);
    var formateAddressDesc = function formateAddressDesc(address) {
      var resArr = [
      // address.contact_name || "",
      // address.contact_number || "",
      formatLocation(address.location)];
      return resArr.filter(function (item) {
        return !!item;
      }).join(", ");
    };
    var handleChooseAddress = function handleChooseAddress(id) {
      selectedAddressId.value = id;
    };
    var handleSelectAddress = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _targetAddress$locati;
        var targetAddress, targetShop;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              targetAddress = addressList.value.find(function (item) {
                return item.id === selectedAddressId.value;
              });
              if (targetAddress !== null && targetAddress !== void 0 && (_targetAddress$locati = targetAddress.location) !== null && _targetAddress$locati !== void 0 && _targetAddress$locati.map_location) {
                _context.next = 4;
                break;
              }
              showToast(t("plsChooseDifferentAddress"));
              return _context.abrupt("return");
            case 4:
              _context.next = 6;
              return selfDeliveryGetShop(targetAddress);
            case 6:
              targetShop = _context.sent;
              if (!targetShop) {
                _context.next = 32;
                break;
              }
              showLoading();
              _context.next = 11;
              return addressStore.selectAddress(selectedAddressId.value);
            case 11:
              hideLoading();
              if (!route.query.toName) {
                _context.next = 26;
                break;
              }
              if (!(shopStore.getShopId === targetShop.shop_id)) {
                _context.next = 20;
                break;
              }
              _context.next = 16;
              return shopStore.switchShop(targetShop);
            case 16:
              userStore.setOrderType(OrderTypeEnum.SELF_DELIVERY);
              if (route.query.isForceGo) {
                routerPush({
                  name: route.query.toName
                });
              } else {
                routerBack();
              }
              _context.next = 24;
              break;
            case 20:
              _context.next = 22;
              return shopStore.switchShop(targetShop, {
                showToast: true
              });
            case 22:
              userStore.setOrderType(OrderTypeEnum.SELF_DELIVERY);
              routerPush({
                name: route.query.toName
              });
            case 24:
              _context.next = 30;
              break;
            case 26:
              _context.next = 28;
              return shopStore.switchShop(targetShop, {
                showToast: true
              });
            case 28:
              userStore.setOrderType(OrderTypeEnum.SELF_DELIVERY);
              routerBack();
            case 30:
              _context.next = 33;
              break;
            case 32:
              // 提醒地址附近无可用店铺
              // showToast("No Available Shop Nearby");
              Dialog.confirm({
                title: t("noNearbyStore"),
                desc: t("noNearbyStoreDesc"),
                okText: t("ok"),
                withoutCancel: true
              });
            case 33:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function handleSelectAddress() {
        return _ref.apply(this, arguments);
      };
    }();
    var handleAddAddress = function handleAddAddress() {
      if (addressList.value.length >= 10) {
        showToast(t("addUpTo10"));
        return;
      }
      routerPush({
        name: "AddressEdit"
      });
    };
    var handleEditAddress = function handleEditAddress(id) {
      routerPush({
        name: "AddressEdit",
        query: {
          id: id
        }
      });
    };
    onMounted(function () {
      nextTick(function () {
        if (addressList.value.length === 0 && !route.query.isBanAutoToAdd) {
          // 自动跳到新增店铺页面
          var query = _objectSpread(_objectSpread({}, route.query), {}, {
            isBanAutoToAdd: true
          });
          routerReplace({
            name: "AddressList",
            query: query
          });
          setTimeout(function () {
            handleAddAddress();
          }, 250);
        } else {
          if (addressStore.getNotifySuccessText) {
            Notify.success(addressStore.getNotifySuccessText);
            addressStore.setNotifySuccessText("");
          }
        }
      });
    });
    return function (_ctx, _cache) {
      var _component_Page = _resolveComponent("Page");
      return _openBlock(), _createBlock(_component_Page, {
        title: _ctx.$t('addressList'),
        class: "al-ctn",
        "is-yellow-bg": "",
        "show-footer": ""
      }, {
        footer: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_withDirectives(_createVNode(Button, {
            disabled: !selectedAddressId.value,
            class: "al-btn",
            onClick: handleSelectAddress
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("selectThisAddress")), 1)];
            }),
            _: 1
          }, 8, ["disabled"]), [[_vShow, addressList.value.length > 0]]), _createVNode(Button, {
            type: "border",
            class: "al-btn",
            onClick: handleAddAddress
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("addNewAddress")), 1)];
            }),
            _: 1
          })])])];
        }),
        default: _withCtx(function () {
          return [_withDirectives(_createVNode(StickyPowerBy, {
            class: "al-list"
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addressList.value, function (address) {
                return _openBlock(), _createElementBlock("div", {
                  key: address.id,
                  class: "al-item",
                  onClick: function onClick($event) {
                    return handleChooseAddress(address.id);
                  }
                }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
                  src: require("@/assets/images/select_".concat(address.id === selectedAddressId.value ? 1 : 0, ".svg"))
                }, null, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(address.contact_name), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(address.contact_number), 1)]), _createElementVNode("div", _hoisted_8, _toDisplayString(formateAddressDesc(address)), 1)]), _createElementVNode("div", {
                  class: "link-ctn",
                  onClick: _withModifiers(function ($event) {
                    return handleEditAddress(address.id);
                  }, ["stop"])
                }, _cache[0] || (_cache[0] = [_createElementVNode("img", {
                  src: _imports_0
                }, null, -1)]), 8, _hoisted_9)], 8, _hoisted_1);
              }), 128))];
            }),
            _: 1
          }, 512), [[_vShow, addressList.value.length > 0]]), _withDirectives(_createElementVNode("div", _hoisted_10, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("notHaveAnyAddresses")), 1)], 512), [[_vShow, addressList.value.length <= 0]])];
        }),
        _: 1
      }, 8, ["title"]);
    };
  }
};